import queryFirebaseCollection from "./queryFirebaseCollection";

export const getFireStoreData = async (
  firebaseConfigDocument: string,
  firebaseDefiDocument: string
) => {
  const [firestoreData, defiData] = await Promise.all([
    queryFirebaseCollection("data", firebaseConfigDocument, true),
    queryFirebaseCollection("defi", firebaseDefiDocument, true),
  ]);
  return { defiData, firestoreData };
};

export default getFireStoreData;
